import { render, staticRenderFns } from "./TabWorldClock.vue?vue&type=template&id=8b6ef282&scoped=true"
import script from "./TabWorldClock.vue?vue&type=script&lang=js"
export * from "./TabWorldClock.vue?vue&type=script&lang=js"
import style0 from "./TabWorldClock.vue?vue&type=style&index=0&id=8b6ef282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6ef282",
  null
  
)

export default component.exports